const chartButtons = [
    {
      id: 0,
      text: "Day",
      unit: "day",
      selected: false,
    },
    {
      id: 1,
      text: "Week",
      unit: "week",
      selected: false,
    },
    {
      id: 2,
      text: "Month",
      unit: "month",
      selected: true,
    },
    {
      id: 3,
      text: "Year",
      unit: "year",
      selected: false,
    },
  ];

  export default chartButtons